import Config from 'react-native-config';
import { RootDispatch } from 'store/types';
import {
  lowPriorityItemsRequestStateSelector,
  highPriorityItemsRequestStateSelector
} from './selectors';

export const GET_LOW_PRIORITY_ITEMS = 'PRIORITY_ITEMS.GET_LOW_PRIORITY_ITEMS';
export const GET_LOW_PRIORITY_ITEMS_SUCCESS = 'PRIORITY_ITEMS.GET_LOW_PRIORITY_ITEMS_SUCCESS';
export const GET_LOW_PRIORITY_ITEMS_FAIL = 'PRIORITY_ITEMS.GET_LOW_PRIORITY_ITEMS_FAIL';

export const getLowPriorityItems = (useRequestState = true) => (dispatch: RootDispatch) => {
  return dispatch({
    client: 'lowPriorityItems',
    type: GET_LOW_PRIORITY_ITEMS,
    payload: {
      useRequestState,
      requestStateSelector: lowPriorityItemsRequestStateSelector,
      request: {
        method: 'get',
        baseURL: `${Config.LOW_PRIORITY_ITEMS_EXPANSION_BASE_URL}`
      }
    }
  });
};

export const GET_HIGH_PRIORITY_ITEMS = 'PRIORITY_ITEMS.GET_HIGH_PRIORITY_ITEMS';
export const GET_HIGH_PRIORITY_ITEMS_SUCCESS = 'PRIORITY_ITEMS.GET_HIGH_PRIORITY_ITEMS_SUCCESS';
export const GET_HIGH_PRIORITY_ITEMS_FAIL = 'PRIORITY_ITEMS.GET_HIGH_PRIORITY_ITEMS_FAIL';

export const getHighPriorityItems = (useRequestState = true) => (dispatch: RootDispatch) => {
  return dispatch({
    client: 'highPriorityItems',
    type: GET_HIGH_PRIORITY_ITEMS,
    payload: {
      useRequestState,
      requestStateSelector: highPriorityItemsRequestStateSelector,
      request: {
        method: 'get',
        baseURL: `${Config.HIGH_PRIORITY_ITEMS_EXPANSION_BASE_URL}`
      }
    }
  });
};
